export default "/profile/images/instruction-4-ru.webp?77d5ddbe199256939614dc6f77acc1bd";